<header class="absolute top-0 left-0 right-0 h-[76px] z-50 px-[22px] pt-[14px]">
  <div class="kga-navbar flex items-center justify-between px-3 py-2">
    <div class="flex items-center gap-3">
      <img src="/assets/layout/kga-logo.png" alt="KGA Logo" class="w-11 h-11 object-cover rounded-2xl shadow-md" (click)="redirectModule()"/>
      <div>
        <div class="font-bold text-[18px] leading-tight tracking-tight" style="color: rgb(47, 52, 48)">
          Karnataka Golf Association
        </div>
        <div class="text-[10px] font-medium tracking-wide" style="color: rgba(47, 52, 48, 0.55)">
          Member Portal
        </div>
      </div>
    </div>
    <!-- <div class="relative w-[583px]">
      <div class="absolute left-[15px] top-1/2 -translate-y-1/2 text-[#202224]/60">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-search w-5 h-5" aria-hidden="true">
          <path d="m21 21-4.34-4.34"></path>
          <circle cx="11" cy="11" r="8"></circle>
        </svg>
      </div>
      <input type="text" placeholder="Search members..."
        class="w-full h-[46px] pl-12 pr-4 bg-slate-50 rounded-[28px] border border-[#cad5e2] font-medium text-sm text-[#202224] placeholder:text-[#717182] focus:outline-none focus:ring-2 focus:ring-[#004f3b]/20 shadow-sm transition-shadow focus:border-[#004f3b]" />
    </div> -->
    <div class="flex items-center gap-6">
      <!-- <div
        class="flex items-center gap-1 bg-white/40 backdrop-blur-sm rounded-full px-1.5 py-1 shadow-sm hover:shadow-md transition-all duration-300">

        <div
          class="p-1.5 rounded-full transition-all duration-300 cursor-pointer group text-gray-500 hover:bg-[#d4e8ca] hover:text-[#000000]">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            class="w-4 h-4 group-hover:scale-110 transition-all duration-300">

            <path d="M10.268 21a2 2 0 0 0 3.464 0"></path>
            <path
              d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326">
            </path>

          </svg>
        </div>

        <div
          class="p-1.5 rounded-full transition-all duration-300 cursor-pointer group text-gray-500 hover:bg-[#d4e8ca] hover:text-[#000000]">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            class="w-4 h-4 group-hover:scale-110 transition-all duration-300">

            <path
              d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915">
            </path>
            <circle cx="12" cy="12" r="3"></circle>

          </svg>
        </div>

      </div> -->
      <div class="relative">
        <div (click)="toggleDropdown()"
          class="flex items-center gap-2 px-2 py-1 rounded-full transition-all duration-300 cursor-pointer group">

          <div class="relative">
            @if (memberPhoto) {
            <img [attr.src]="memberPhoto" alt="Profile" (error)="onMemberPhotoError()"
              class="w-[32px] h-[32px] object-cover rounded-full shadow-md ring-2 ring-white/70 transition-all duration-300" />
            } @else {
            <div
              class="w-[32px] h-[32px] rounded-full shadow-md ring-2 ring-white/70 flex items-center justify-center text-[11px] font-semibold text-[#ffffff] bg-[#7163ba]">
              {{ (memberName || 'M').charAt(0) }}
            </div>
            }

            <div class="absolute -bottom-0.5 -right-0.5 w-2 h-2 rounded-full border ">
            </div>
          </div>

          <div class="flex flex-col gap-0.5 pr-1 leading-tight">
            <span class="font-semibold text-[9px] md:text-[11px] text-[#202224]">
              {{ memberName }}
            </span>
            @if (memberCode) {
            <span class="text-[7px] md:text-[9px] font-black text-[#202224] tracking-wide">
              {{ memberCode }}
            </span>
            }
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            class="w-3.5 h-3.5 text-[#202224] transition-transform duration-300">

            <path d="m6 9 6 6 6-6"></path>

          </svg>

        </div>
        @if (isDropdownOpen) {
        <div
          class="absolute top-[43px] right-0 w-[144px] rounded-xl shadow-[0_20px_60px_0_rgba(0,0,0,0.25)] overflow-hidden z-[9999] animate-in slide-in-from-top-2 duration-300"
          style="background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.95) 100%); backdrop-filter: blur(20px); border: 1px solid rgba(255, 255, 255, 0.8);">
          <!-- <button (click)="navigateToProfile()"
            class="w-full flex items-center gap-3 p-2 transition-all duration-300 hover:bg-gradient-to-r hover:from-green-50/80 hover:to-green-100/60 group border-b border-gray-100">
            <div
              class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110"
              style="background: linear-gradient(135deg, rgb(74, 133, 39) 0%, rgb(95, 168, 50) 100%); box-shadow: rgba(95, 168, 50, 0.25) 0px 3px 12px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-circle-user text-white" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <circle cx="12" cy="10" r="3"></circle>
                <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"></path>
              </svg>
            </div>
            <div class="flex-1 text-left">
              <div class="text-[12px] font-bold text-gray-800">My Profile</div>
              <div class="text-[8px] text-gray-500 font-medium">Update your profile</div>
            </div>
          </button> -->
          <!-- <button
            class="w-full flex items-center gap-3 p-2 transition-all duration-300 hover:bg-gradient-to-r hover:from-amber-50/80 hover:to-amber-100/60 group border-b border-gray-100">
            <div
              class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110"
              style="background: linear-gradient(135deg, rgb(245, 158, 11) 0%, rgb(217, 119, 6) 100%); box-shadow: rgba(245, 158, 11, 0.25) 0px 3px 12px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-key text-white" aria-hidden="true">
                <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4"></path>
                <path d="m21 2-9.6 9.6"></path>
                <circle cx="7.5" cy="15.5" r="5.5"></circle>
              </svg>
            </div>
            <div class="flex-1 text-left">
              <div class="text-[12px] font-bold text-gray-800">Change Password</div>
              <div class="text-[8px] text-gray-500 font-medium">Update credentials</div>
            </div>
          </button> -->
          <button type="button" (click)="signOut()"
            class="w-full flex items-center gap-3 p-2 transition-all duration-300 hover:bg-gradient-to-r hover:from-red-50/80 hover:to-red-100/60 group">
            <div
              class="w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300 group-hover:scale-110"
              style="background: linear-gradient(135deg, rgb(239, 68, 68) 0%, rgb(220, 38, 38) 100%); box-shadow: rgba(239, 68, 68, 0.25) 0px 3px 12px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-log-out text-white" aria-hidden="true">
                <path d="m16 17 5-5-5-5"></path>
                <path d="M21 12H9"></path>
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              </svg>
            </div>
            <div class="flex-1 text-left" (click)="logout()">
              <div class="text-[12px] font-bold text-gray-800">Sign Out</div>
              <div class="text-[8px] text-gray-500 font-medium">Logout from portal</div>
            </div>
          </button>
        </div>
        }
      </div>
    </div>
  </div>
</header>